import { action, observable } from 'mobx';
import { api } from '../config';

// Helpers
import { getPath, removeEmptyQueryParams } from '../helpers/helpers';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  proctorSid: null,
  proctor: [],
  proctorLocationSid: null,
  // Get proctor data
  getProctor: action(function(sid, component, callback) {
    SessionStore.startLoading('Loading…', 'GetProctorData');
    obx.proctorSid = null;
    obx.proctor = [];

    api.get(`/proctors/${sid}`)
      .then(response => {
        obx.proctor = response.data;
        obx.proctorSid = response.data.sid;

        if(component) {
          component.setState({
            accountData: response.data
          });
        }

        if(callback) {
          callback(response.data);
        }

        SessionStore.finishLoading('GetProctorData');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  proctorGroups: [],
  // Get proctor groups
  getProctorGroups: action(function (component, callback) {
    SessionStore.startLoading('Loading…', 'GetProctorGroups');

    api.get(`/installs/${SessionStore.userData.installSid}/proctorGroup`)
      .then(response => {
        obx.proctorGroups = response.data.results;
        SessionStore.finishLoading('GetProctorGroups');

        if(component) {
          component.setState({
            groups: response.data.results
          })
        }

        if(response.data.results.length === 0 && callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get session proctor groups
  getSessionProctorGroups: action(function (examSid, sessionSid, component, callback) {
    SessionStore.startLoading('Loading…', 'GetProctorGroups');

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/proctorGroups`)
      .then(response => {
        obx.proctorGroups = response.data.results;

        if(component) {
          component.setState({
            groups: response.data.results
          })
        }

        if(callback) {
          callback(response.data.results);
        }

        SessionStore.finishLoading('GetProctorGroups');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get all proctor categories
  proctorTypeCategories: [],
  getProctorTypes: action(function(component) {
    SessionStore.startLoading('Loading…', 'GetProctorTypes');

    api.get(`/proctors/categories?selfSelection=all`)
      .then(response => {
        // Store an array of category sids
        response.data.results.forEach(function(group){
          group.subCategories.forEach(function(category){
            obx.proctorCategories.push(category.sid);
            return true;
          });

          return true;
        });

        // Also store an array of objects with sid and title
        response.data.results.forEach(function(group){
          group.subCategories.forEach(function(category){
            const catObj = {
              sid: category.sid,
              title: category.title
            }

            obx.proctorTypeCategories.push(catObj);

            return true;
          });

          return true;
        });

        SessionStore.finishLoading('GetProctorTypes');
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  // Get proctor group categories
  proctorCategories: [],
  getProctorGroupCategories: action(function(examSid, sessionSid, groupSid, callback, component){
    SessionStore.startLoading('Loading…', 'GetProctorGroupCategories');

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/proctorGroups`)
      .then(response => {
        response.data.results.forEach(function(group){
          if(group.sid === groupSid) {
            obx.proctorCategories = group.proctorTypes;
            return true;
          }
        });

        SessionStore.finishLoading('GetProctorGroupCategories');

        if(callback) {
          callback(component);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });

    // api.get(`/installs/${SessionStore.userData.installSid}/proctorGroup/${groupSid}`)
    //   .then(response => {
    //     obx.proctorCategories = response.data.proctorTypes;
    //     SessionStore.finishLoading('GetProctorGroupCategories');
    //
    //     if(callback) {
    //       callback(component);
    //     }
    //   })
    //   .catch(error => {
    //     SessionStore.throwError(error);
    //   });
  }),
  // Update proctor groups
  updateProctorGroups: action(function (data, callback) {
    SessionStore.startLoading('Loading…', 'UpdateProctorGroups');

    // Remove unnecessary data
    data.forEach(function (group) {
      if(group) {
        delete group.createdDate;
        delete group.editDate;
        delete group.sortOrder;

        // These properties are used in the UI state
        // and are not allowed by the API
        delete group.locations;
        delete group.gotLocations;
        delete group.proctorLocations;
        delete group.proctorLocationDetails;
      }
    });

    api.put(`/installs/${SessionStore.userData.installSid}/proctorGroup`, data)
      .then(response => {
        obx.proctorGroups = response.data.results;
        SessionStore.finishLoading('UpdateProctorGroups');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  selfManagedAccounts: [],
  // Get all self-managed accounts
  listSelfManagedAccount: action(function listSelfManagedAccount() {
    SessionStore.startLoading('Loading…', 'ListSelfManagedAccount');

    obx.proctorSid = null;

    // Take deploymentOwnerSid from userData
    let deploymentOwnerSid = SessionStore.userData.deploymentSid;

    api.get(`/proctorAccounts/${deploymentOwnerSid}`)
      .then(response => {
        obx.selfManagedAccounts = response.data.results;
        SessionStore.finishLoading('ListSelfManagedAccount');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Add self-managed account
  addSelfManagedAccount: action(function addSelfManagedAccount(data, callback, component) {
    SessionStore.startLoading('Loading…', 'AddSelfManagedAccounts');

    data.deploymentOwnerSid = SessionStore.userData.deploymentSid;
    data.type = 'individual-proctor'

    // Delete phone because we don't have delete field in api
    if(data.phone) {
      delete data.phone;
    }

    api.post(`/proctors`, data)
      .then(response => {
        obx.proctor = response.data;
        obx.proctorSid = response.data.sid;
        obx.proctor.proctorTypes = [];

        if(component) {
          component.setState({
            accountData: obx.proctor,
            mode: 'edit'
          })
        }

        setTimeout(function(){
          SessionStore.finishLoading('AddSelfManagedAccounts');
          callback();
        });
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update self-managed account
  updateSelfManagedAccount: action(function updateSelfManagedAccount(proctorSid, data, callback) {
    SessionStore.startLoading('Loading…', 'UpdateSelfManagedAccounts');

    delete data.sid;
    delete data.createdDate;
    delete data.editDate;
    delete data.verificationDate;
    delete data.verifiedBy;
    delete data.deploymentOwnerSid;
    delete data.authentication;
    delete data.type;
    delete data.active;
    delete data.metadata;
    delete data.timeZoneSid;

    if(!data.accountName) {
      data.accountName = '';
    }

    api.put(`/proctors/${proctorSid}`, data)
      .then(response => {
        SessionStore.finishLoading('UpdateSelfManagedAccounts');
        callback();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Search proctors
  proctors: [],
  proctorsTotal: 0,
  searchQuery: null,
  proctorsNext: null,
  resetProctors: action(function(){
    obx.proctors = [];
    obx.searchQuery = null;
  }),
  searchProctors: action(function(query, callback, i, backgroundLoad, appendResult, noUpdate = false){
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'SearchProctors');
    } else {
      SessionStore.startBackgroundLoading('SearchProctors');
    }

    if(!appendResult && !noUpdate) {
      obx.resetProctors();
    }

    let currencyCode = null;

    if(SessionStore.profile && SessionStore.profile.currencyCode) {
      currencyCode = SessionStore.profile.currencyCode;
    } else {
      currencyCode = 'USD';
    }

    if(typeof query === 'undefined' || !query) {
      query = `?currencyCode=${currencyCode}`;
    } else if(query.indexOf('currencyCode') < 0) {
      query += `&currencyCode=${currencyCode}`;
    }

    // clean up the empty query params
    query = removeEmptyQueryParams(query);

    if (!noUpdate) {
      obx.searchQuery = query;
    }

    api.get(`/installs/${SessionStore.userData.installSid}/proctors/search${query}`)
      .then(response => {
        if(callback) {
          callback(i, response.data.results);
        }

        if (!noUpdate) {
          if(appendResult) {
            Array.prototype.push.apply(obx.proctors, response.data.results);
          } else {
            obx.proctors = response.data.results;
          }
        }

        if(!backgroundLoad) {
          SessionStore.finishLoading('SearchProctors');
        } else {
          SessionStore.finishBackgroundLoading('SearchProctors');
        }

        if (!noUpdate) {
          if(response.data.next) {
            // API returns a url with a different domain for the next link
            // so create an anchor element and set its href to the next link
            // and then grab the pathname and query from that
            let nextUrl = getPath(response.data.next);
            nextUrl = nextUrl.replace('/v1', '').replace('&appointmentDate=null', '');
            obx.proctorsNext = nextUrl;
          } else {
            obx.proctorsNext = null;
          }
          obx.proctorsTotal = response.data.total;
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  // Get proctor group location details
  getLocationDetails: action(function(locationSids, i, component) {
    SessionStore.startLoading('Loading…', 'GetLocationDetails');

    // Make an API call for each locationSid
    for(let j = 0; j < locationSids.length; j++) {
      const query = `?proctorLocationSids=${locationSids[j]}`;

      api.get(`/installs/${SessionStore.userData.installSid}/proctors/search${query}`)
        .then(response => {
          obx.proctorLocation = response.data.results[0];

          if(i || i === 0) {
            let groups = [...component.state.groups];

            if(groups) {
              if(!groups[i].proctorLocationDetails) {
                groups[i].proctorLocationDetails = {};
              }

              groups[i].proctorLocationDetails[locationSids[j]] = response.data.results[0];

              component.setState({
                groups
              });
            }
          }

          SessionStore.finishLoading('GetLocationDetails');
        })
        .catch(error => {
          SessionStore.throwError(error);
        })
    }
  }),
  // Request approval
  requestApproval: action(function(data, isAdmin, forStudent){
    api.post(`/installs/${SessionStore.userData.installSid}/approvals`, data)
      .then(response => {
        if(isAdmin) {
          let data = {
            reviewedByUserSid: SessionStore.profile.sid,
            status: 'allow',
            applyTo: 'install'
          }

          if(forStudent) {
            data.applyTo = 'student'
          }

          obx.updatePendingApprovals(response.data.sid, data);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Administrator create approval
  createApproval: action(function(data, callback){
    SessionStore.startLoading('Loading…', 'CreateApproval');

    api.post(`/installs/${SessionStore.userData.installSid}/approve`, data)
      .then(response => {
        SessionStore.finishLoading('CreateApproval');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Proctor approvals
  pendingApprovals: [],
  getPendingApprovals: action(function(query){
    SessionStore.startLoading('Loading…', 'GetPendingApprovals');

    api.get(`/installs/${SessionStore.userData.installSid}/approvals${query}`)
      .then(response => {
        obx.pendingApprovals = response.data.results;
        SessionStore.finishLoading('GetPendingApprovals');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get single proctor’s approval history
  getSingleApproval: action(function(component, proctorSid){
    SessionStore.startBackgroundLoading('getSingleApproval');

    const query = `?sortOrder=DESC&proctorSid=${proctorSid}&status=allow&status=deny`

    api.get(`/installs/${SessionStore.userData.installSid}/approvals${query}`)
      .then(response => {
        if(component) {
          component.setState({
            approvals: response.data.results
          })
        }

        SessionStore.finishBackgroundLoading('getSingleApproval');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Approve or deny
  updatePendingApprovals: action(function(approvalSid, data, callback, showLoader){
    if(showLoader) {
      SessionStore.startLoading('Loading…', 'updatePendingApprovals');
    }

    api.put(`/installs/${SessionStore.userData.installSid}/approvals/${approvalSid}`, data)
      .then(response => {
        // obx.pendingApprovals = response.data.results;

        if(showLoader) {
          SessionStore.finishLoading('updatePendingApprovals');
        }
        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete approval
  deleteProctorApproval: action(function(approvalSid, callback){
    SessionStore.startLoading('Loading…', 'DeleteProctorApproval');

    api.delete(`/installs/${SessionStore.userData.installSid}/approvals/${approvalSid}`)
      .then(response => {
        SessionStore.finishLoading('DeleteProctorApproval');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get course data for approval
  approvalCourseData: {},
  getApprovalCourseData: action(function(approvalSid, courseSid){
    SessionStore.startLoading('Loading…', 'GetApprovalCourseData');

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${courseSid}`)
      .then(response => {
        obx.approvalCourseData[approvalSid] = response.data;
        SessionStore.finishLoading('GetApprovalCourseData');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
    /**
   * provisionOnlineSession
   * @param {object} data
   * @param {function} callback
   */
  provisionOnlineSession: action(function(data, callback) {
    SessionStore.startLoading('provisionOnlineSession');

    const { examSid, installSid, sessionSid } = data;

    api.patch(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/provisionExam`)
      .then(response => {
        if(callback) {
          callback(response.data.interoadsProvisionedExamUrl);
        }

        SessionStore.finishLoading('provisionOnlineSession');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ProctorStore.js